// DISABLED: Stripe checkout — payments are now handled by private invoices.
// Original Stripe SDK, EmbeddedCheckout, and payment polling are commented out.

import React from 'react';
// import React, { useEffect, useCallback } from 'react';
// import { loadStripe } from '@stripe/stripe-js';
// import {
//   EmbeddedCheckoutProvider,
//   EmbeddedCheckout,
// } from '@stripe/react-stripe-js';
import {
  CardDetailDescText,
  CardDetailHighlight,
  CardDetailsDescription,
  CardDetailTitle,
  CardPlanDetails,
  Divider,
  PageTitle,
} from './checkout.styled';
import { VSpace } from '../../../account/account-settings';
// import { useCheckoutSession } from './checkout.hooks';
// import { paymentsApi } from '../../../../../../api/payments/payments';
// import { usePayment } from '../../../../../../contexts/payment-context';
import { PLANS } from '../../billing.constants';

// const STRIPE_KEY = import.meta.env.VITE_STRIPE_PUBLISHABLE_KEY;
// if (!STRIPE_KEY) {
//   console.error('VITE_STRIPE_PUBLISHABLE_KEY is not set — checkout will not work');
// }
// const stripePromise = STRIPE_KEY ? loadStripe(STRIPE_KEY) : null;

export type CheckoutModalProps = {
  open: boolean;
  onClose: () => void;
  onSubscribe: () => void;
  planName?: string;
  billingCycle?: 'annual' | 'monthly';
};

const CheckoutModal: React.FC<CheckoutModalProps> = (props) => {
  const { open, onClose, planName = 'Sanctum', billingCycle = 'annual' } = props;

  // const { clientSecret, status, error, createSession, reset } = useCheckoutSession();
  // const { trialExpired, isOnTrial } = usePayment();

  // Map UI values to backend API values
  const rawPlanLower = planName.toLowerCase();
  const apiPlan =
    rawPlanLower === 'north star' || rawPlanLower === 'north_star' ? 'north_star' : 'sanctum';
  // const apiInterval = billingCycle === 'annual' ? 'year' : 'month';
  // const skipTrial = isOnTrial || trialExpired;

  // // Refs for polling lifecycle
  // const mountedRef = React.useRef(true);
  // const pollTimerRef = React.useRef<ReturnType<typeof setTimeout> | null>(null);

  // React.useEffect(() => {
  //   mountedRef.current = true;
  //   return () => {
  //     mountedRef.current = false;
  //     if (pollTimerRef.current) clearTimeout(pollTimerRef.current);
  //   };
  // }, []);

  // useEffect(() => {
  //   if (open && status === 'idle') {
  //     createSession(apiPlan, apiInterval, skipTrial);
  //   }
  // }, [open, status, apiPlan, apiInterval, skipTrial, createSession]);

  // Reset state when modal closes
  // useEffect(() => {
  //   if (!open) {
  //     reset();
  //     setPollError(null);
  //     setManageError(null);
  //     if (pollTimerRef.current) {
  //       clearTimeout(pollTimerRef.current);
  //       pollTimerRef.current = null;
  //     }
  //   }
  // }, [open, reset]);

  // Calculate pricing for the summary from centralized constants
  const getPricingInfo = () => {
    const isNorthStar = apiPlan === 'north_star';
    const isAnnual = billingCycle === 'annual';
    const planConfig = isNorthStar ? PLANS.northStar : PLANS.sanctum;

    return {
      pricePerMonth: isAnnual ? planConfig.pricing.annualMonthly : planConfig.pricing.monthly,
      totalPrice: isAnnual ? planConfig.pricing.annualTotal : undefined,
      billingText: isAnnual ? 'billed at outset of 12-month subscription' : 'billed each month',
      savingsText: isAnnual
        ? `Save $${planConfig.pricing.annualSavings.toLocaleString()} per annum`
        : undefined,
    };
  };

  const pricing = getPricingInfo();

  // const [pollError, setPollError] = React.useState<string | null>(null);

  // // Poll payment info to confirm the subscription was created
  // const handleComplete = useCallback(async () => {
  //   setPollError(null);
  //   try {
  //     let attempts = 0;
  //     const poll = async () => {
  //       if (!mountedRef.current) return;
  //       try {
  //         const info = await paymentsApi.getMe();
  //         if (!mountedRef.current) return;
  //         if (info.has_active_subscription) {
  //           window.dispatchEvent(new Event('payment:updated'));
  //           onSubscribe();
  //           return;
  //         }
  //       } catch {
  //         // transient error, keep polling
  //       }
  //       attempts++;
  //       if (attempts < 10) {
  //         pollTimerRef.current = setTimeout(poll, 2000);
  //       } else {
  //         if (mountedRef.current) {
  //           setPollError(
  //             'Your payment was received but your subscription is still being activated. ' +
  //               'This usually takes a few seconds. Please close and check back shortly.'
  //           );
  //           window.dispatchEvent(new Event('payment:updated'));
  //         }
  //       }
  //     };
  //     await poll();
  //   } catch {
  //     if (mountedRef.current) {
  //       setPollError(
  //         'Something went wrong verifying your subscription. Please check back shortly.'
  //       );
  //     }
  //   }
  // }, [onSubscribe]);

  // const [manageError, setManageError] = React.useState<string | null>(null);

  // const handleManageSubscription = async () => {
  //   setManageError(null);
  //   try {
  //     const { url } = await paymentsApi.createPortalSession();
  //     window.open(url, '_blank');
  //     onClose();
  //   } catch {
  //     setManageError('Failed to open billing portal. Please try again.');
  //   }
  // };

  if (!open) return null;

  return (
    <div
      style={{
        position: 'absolute',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        paddingBottom: 'env(safe-area-inset-bottom, 0px)',
        boxSizing: 'border-box',
        overflowY: 'auto',
        WebkitOverflowScrolling: 'touch',
      }}
    >
      {/* Header with only logo */}
      <header
        style={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          padding: '20px',
          paddingTop: 'calc(20px + env(safe-area-inset-top, 0px))',
          position: 'sticky',
          top: 0,
          background: '#1A1A1C',
          zIndex: 1,
          flexShrink: 0,
        }}
      >
        <img src="/main-logo-white.svg" alt="logo" width={124} height="auto" draggable={false} />
      </header>

      <div>
        <div style={{ padding: '20px' }}>
          <PageTitle>Checkout</PageTitle>
          <VSpace $h={16} />

          {/* Plan summary */}
          <CardPlanDetails>
            <CardDetailTitle>{planName}</CardDetailTitle>
            <CardDetailsDescription>
              <CardDetailDescText>
                {billingCycle === 'annual' ? 'Annual' : 'Monthly'} Subscription
              </CardDetailDescText>
              <CardDetailDescText>
                ${pricing.pricePerMonth.toLocaleString()} per month{' '}
                {billingCycle === 'annual' ? '(after discount)' : ''}
              </CardDetailDescText>
              {pricing.totalPrice && (
                <CardDetailDescText>
                  ${pricing.totalPrice.toLocaleString()} {pricing.billingText}
                </CardDetailDescText>
              )}
              {pricing.savingsText && (
                <CardDetailHighlight>{pricing.savingsText}</CardDetailHighlight>
              )}
            </CardDetailsDescription>
            <Divider />
          </CardPlanDetails>

          <VSpace $h={24} />

          {status === 'loading' && (
            <div
              style={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                padding: '40px',
                color: '#B7BDCB',
                fontSize: '15px',
                fontFamily: 'Inter',
              }}
            >
              Loading checkout...
            </div>
          )}
          {/*
          {!stripePromise && (
            <div
              style={{
                padding: '20px',
                background: '#1E1F22',
                borderRadius: '12px',
                outline: '1px #2b2d33 solid',
                outlineOffset: '-1px',
              }}
            >
              <span style={{ color: '#D65F46', fontSize: '15px', fontFamily: 'Inter', fontWeight: 500 }}>
                Checkout is currently unavailable. Please try again later.
              </span>
            </div>
          )}

          {status === 'error' && error && (
            <div
              style={{
                display: 'flex',
                flexDirection: 'column',
                gap: '16px',
                padding: '20px',
                background: '#1E1F22',
                borderRadius: '12px',
                outline: '1px #2b2d33 solid',
                outlineOffset: '-1px',
              }}
            >
              <span
                style={{
                  color: '#D65F46',
                  fontSize: '15px',
                  fontFamily: 'Inter',
                  fontWeight: 500,
                  lineHeight: '21px',
                }}
              >
                {error}
              </span>
              {error.includes('active subscription') ? (
                <button
                  style={{
                    display: 'flex',
                    height: '44px',
                    width: '100%',
                    background: '#5E84ED',
                    borderRadius: '12px',
                    justifyContent: 'center',
                    alignItems: 'center',
                    color: 'white',
                    fontSize: '15px',
                    fontFamily: 'Inter',
                    fontWeight: 600,
                    lineHeight: '21px',
                    cursor: 'pointer',
                    outline: 'none',
                    border: 'none',
                  }}
                  onClick={handleManageSubscription}
                >
                  Manage Subscription
                </button>
              ) : (
                <button
                  style={{
                    display: 'flex',
                    height: '44px',
                    width: '100%',
                    background: '#2b2d33',
                    borderRadius: '12px',
                    justifyContent: 'center',
                    alignItems: 'center',
                    color: '#B7BDCB',
                    fontSize: '15px',
                    fontFamily: 'Inter',
                    fontWeight: 600,
                    lineHeight: '21px',
                    cursor: 'pointer',
                    outline: 'none',
                    border: 'none',
                  }}
                  onClick={reset}
                >
                  Try Again
                </button>
              )}
            </div>
          )}

          {status === 'ready' && clientSecret && (
            <EmbeddedCheckoutProvider
              stripe={stripePromise}
              options={{
                clientSecret,
                onComplete: handleComplete,
              }}
            >
              <EmbeddedCheckout />
            </EmbeddedCheckoutProvider>
          )}

          {(pollError || manageError) && (
            <div
              style={{
                padding: '16px 20px',
                background: '#1E1F22',
                borderRadius: '12px',
                outline: '1px #2b2d33 solid',
                outlineOffset: '-1px',
                marginTop: '16px',
              }}
            >
              <span
                style={{
                  color: '#E1C27A',
                  fontSize: '14px',
                  fontFamily: 'Inter',
                  fontWeight: 500,
                  lineHeight: '20px',
                }}
              >
                {pollError || manageError}
              </span>
            </div>
          )} */}

          <VSpace $h={32} />

          {/* Go back button */}
          <div
            style={{
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              gap: '16px',
            }}
          >
            <div
              style={{
                height: '44px',
                width: '100%',
                background: 'transparent',
                borderRadius: '12px',
                justifyContent: 'center',
                alignItems: 'center',
                display: 'flex',
              }}
            >
              <button
                style={{
                  color: '#B7BDCB',
                  background: 'transparent',
                  border: 'none',
                  fontSize: '15px',
                  fontFamily: 'Inter',
                  fontWeight: 600,
                  lineHeight: '21px',
                  cursor: 'pointer',
                }}
                onClick={onClose}
              >
                Go back
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CheckoutModal;
